import {styled} from "@mui/material/styles"
import {FALLBACK_FONT_FAMILY} from "@next/ux-fabric"

export const Span = styled("span")`
    color: ${({theme}) => theme.uxfabric.components.link.inherit.enabled.textColor};
    font-family: ${({theme}) => `${theme.uxfabric.global.body3.fontFamily}, ${FALLBACK_FONT_FAMILY}`} !important;
    font-weight: ${({theme}) => `${theme.uxfabric.global.body3.fontWeight}`};
`
